import { TASK_TYPES } from "./actionTypes";

export const SUPPORT_AUTOMATION_API = "/support-automation";

export const AUTOMATION_TASK_OPTIONS = [
  { value: "", label: "Select" },
  {
    value: TASK_TYPES.DELETE_FINANCIAL_FORM_DATA,
    label: "Delete financial form data",
  },
  {
    value: TASK_TYPES.DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA,
    label: "Delete financial from Executive summary",
  },
];

export const TASK_CONFIG = {
  [TASK_TYPES.DELETE_FINANCIAL_FORM_DATA]: {
    sectionTitle: "Delete Financial Form Data",
    description:
      "Fetch case details, take S3 backup, then delete financial form data from backend.",
    requiresBackup: true,
    caseDetailsEndpoint: `${SUPPORT_AUTOMATION_API}/case-details`,
    deleteEndpoint: `${SUPPORT_AUTOMATION_API}/financial-form-data`,
    backupEndpoint: `${SUPPORT_AUTOMATION_API}/financial-form-data/backup`,
    hasDeletableData: (caseDetails) =>
      Boolean(caseDetails?.hasFinancialFormData),
  },
  [TASK_TYPES.DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA]: {
    sectionTitle: "Delete Financial From Executive Summary",
    description:
      "Fetch case details, then delete executive summary financial data.",
    requiresBackup: false,
    caseDetailsEndpoint: `${SUPPORT_AUTOMATION_API}/case-details`,
    deleteEndpoint: `${SUPPORT_AUTOMATION_API}/executive-summary-financial-data`,
    hasDeletableData: (caseDetails) =>
      Boolean(caseDetails?.hasExecutiveSummaryFinancialData),
  },
};

export const getBackupConfigForTask = (taskType) => TASK_CONFIG[taskType] || null;
